// @mui
import PropTypes from 'prop-types';

import { Box } from '@mui/system';
import { Card, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

// components
import Iconify from '../iconify';
// utils
import { fShortenNumber } from '../../utils/formatNumber';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  sx: PropTypes.object,
  iconStyle: PropTypes.object,
  cardTextStyle: PropTypes.object,
  iconSize: PropTypes.number,
};

export default function AppWidgetSummary({
  title,
  total,
  icon,
  color = 'primary',
  sx,
  iconStyle,
  cardTextStyle,
  iconSize = 8,
  ...other
}) {
  const { isSmallScreen } = useResponsiveScreen();
  const StyledIcon = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(iconSize),
    height: theme.spacing(iconSize),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
  }));
  return (
    <Card
      sx={{
        py: isSmallScreen ? 3 : 5,
        boxShadow: 0,
        textAlign: 'center',
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        ...sx,
      }}
      {...other}
    >
      <StyledIcon
        sx={{
          color: (theme) => theme.palette[color].dark,
          backgroundImage: (theme) =>
            `linear-gradient(135deg, ${alpha(theme.palette[color].dark, 0)} 0%, ${alpha(
              theme.palette[color].dark,
              0.24
            )} 100%)`,
          ...iconStyle,
        }}
      >
        <Iconify icon={icon} width={24} height={24} />
      </StyledIcon>

      <Box
        sx={{
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          ...cardTextStyle,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: isSmallScreen && '1.2rem',
          }}
        >
          {total ? fShortenNumber(total) : 0}
        </Typography>

        <Typography
          variant="subtitle2"
          sx={{ opacity: 0.72, fontSize: isSmallScreen && '0.7rem' }}
        >
          {title}
        </Typography>
      </Box>
    </Card>
  );
}
